import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Font,
  Image,
} from "@react-pdf/renderer";

Font.register({
  family: "Manrope",
  fonts: [
    {
      src: "https://fonts.gstatic.com/s/manrope/v15/xn7_tHE41ni1AdIRqXPExKno.ttf",
      fontWeight: "normal",
    },
    {
      src: "https://fonts.gstatic.com/s/manrope/v15/xn7_tHE41ni1AdIRqYPExKno.ttf",
      fontWeight: "bold",
    },
  ],
});

const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontSize: 9,
    fontFamily: "Manrope",
    color: "#333",
    flexDirection: "column",
  },
  headerImage: {
    width: "100%",
    height: 45,
    objectFit: "contain",
    marginBottom: 8,
  },
  title: {
    fontSize: 14,
    fontWeight: 700,
    textAlign: "center",
    marginBottom: 8,
    textTransform: "uppercase",
    borderBottom: 1,
    paddingBottom: 4,
  },
  infoContainer: {
    flexDirection: "column",
    borderWidth: 1,
    borderColor: "#000",
    marginBottom: 10,
  },
  infoRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderColor: "#000",
    minHeight: 25,
  },
  infoRowLast: {
    flexDirection: "row",
    minHeight: 25,
  },
  infoCell: {
    flex: 1,
    padding: 4,
    borderRightWidth: 1,
    borderColor: "#000",
  },
  infoCellLast: {
    flex: 1,
    padding: 4,
  },
  label: {
    fontSize: 7,
    color: "#666",
    textTransform: "uppercase",
    fontWeight: 700,
  },
  value: {
    fontSize: 9,
    fontWeight: 700,
    marginTop: 1,
  },
  tableHeader: {
    flexDirection: "row",
    backgroundColor: "#f2f2f2",
    borderWidth: 1,
    borderColor: "#000",
    alignItems: "center",
  },
  tableRow: {
    flexDirection: "row",
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: "#000",
    minHeight: 20,
    alignItems: "center",
  },
  cell: {
    padding: 3,
    fontSize: 7,
    borderRightWidth: 1,
    borderColor: "#000",
    height: "100%",
    justifyContent: "center",
  },
  cellLast: {
    padding: 3,
    fontSize: 7,
    height: "100%",
    justifyContent: "center",
  },
});

const RectificationJobPrint = ({ data, headerImage }) => {
  if (!data) return null;

  return (
    <Document>
      <Page size="A4" orientation="landscape" style={styles.page}>
        {headerImage && <Image src={headerImage} style={styles.headerImage} />}
        <Text style={styles.title}>Rectification Production Job Card</Text>
        {/* Info Grid */}
        <View style={styles.infoContainer}>
          {/* Row 1 */}
          <View style={styles.infoRow}>
            <View style={styles.infoCell}>
              <Text style={styles.label}>Order No</Text>
              <Text style={styles.value}>{data.orderNo}</Text>
            </View>
            <View style={styles.infoCell}>
              <Text style={styles.label}>Priority</Text>
              <Text style={styles.value}>{data.priority}</Text>
            </View>
            <View style={styles.infoCell}>
              <Text style={styles.label}>Order Date</Text>
              <Text style={styles.value}>{data.orderDate}</Text>
            </View>
            <View style={styles.infoCell}>
              <Text style={styles.label}>Start Date</Text>
              <Text style={styles.value}>{data.startDate}</Text>
            </View>
            <View style={styles.infoCellLast}>
              <Text style={styles.label}>End Date</Text>
              <Text style={styles.value}>{data.endDate}</Text>
            </View>
          </View>
          {/* Row 2 */}
          <View style={styles.infoRow}>
            <View style={styles.infoCell}>
              <Text style={styles.label}>Customer Name</Text>
              <Text style={styles.value}>{data.customerName}</Text>
            </View>
            <View style={styles.infoCell}>
              <Text style={styles.label}>LPO No</Text>
              <Text style={styles.value}>{data.lpoNo}</Text>
            </View>
            <View style={styles.infoCell}>
              <Text style={styles.label}>LPO Date</Text>
              <Text style={styles.value}>{data.lpoDate}</Text>
            </View>
            <View style={styles.infoCell}>
              <Text style={styles.label}>Delivery Desk</Text>
              <Text style={styles.value}>{data.deliveryDesk || "-"}</Text>
            </View>
            <View style={styles.infoCellLast}>
              <Text style={styles.label}>Salesman</Text>
              <Text style={styles.value}>{data.salesman}</Text>
            </View>
          </View>
          {/* Row 3 */}
          <View style={styles.infoRowLast}>
            <View style={styles.infoCell}>
              <Text style={styles.label}>Prepared By</Text>
              <Text style={styles.value}>{data.preparedBy}</Text>
            </View>
            <View style={styles.infoCellLast}>
              <Text style={styles.label}>PROD HEAD</Text>
              <Text style={styles.value}>{data.signature || ""}</Text>
            </View>
          </View>
        </View>
        {/* Main Production Table */}
        <View style={styles.tableHeader}>
          <Text style={[styles.cell, { flex: 0.4, fontWeight: 700 }]}>S#</Text>
          <Text style={[styles.cell, { flex: 1.2, fontWeight: 700 }]}>Code</Text>
          <Text style={[styles.cell, { flex: 2, fontWeight: 700 }]}>Description</Text>
          <Text style={[styles.cell, { flex: 1, fontWeight: 700 }]}>Body</Text>
          <Text style={[styles.cell, { flex: 1, fontWeight: 700 }]}>Size</Text>
          <Text style={[styles.cell, { flex: 1, fontWeight: 700 }]}>CCT</Text>
          <Text style={[styles.cell, { flex: 1, fontWeight: 700 }]}>Driver</Text>
          <Text style={[styles.cell, { flex: 1.5, fontWeight: 700 }]}>L-Source</Text>
          <Text style={[styles.cell, { flex: 0.8, fontWeight: 700 }]}>mA</Text>
          <Text style={[styles.cell, { flex: 0.8, fontWeight: 700 }]}>Qty</Text>
          <Text style={[styles.cellLast, { flex: 1.5, fontWeight: 700 }]}>Remarks</Text>
        </View>
        {data.items.map((row, idx) => (
          <View style={styles.tableRow} key={row.id || idx}>
            <Text style={[styles.cell, { flex: 0.4 }]}>{idx + 1}</Text>
            <Text style={[styles.cell, { flex: 1.2, fontWeight: 700 }]}>{row.code}</Text>
            <Text style={[styles.cell, { flex: 2 }]}>{row.description}</Text>
            <Text style={[styles.cell, { flex: 1 }]}>{row.body}</Text>
            <Text style={[styles.cell, { flex: 1 }]}>{row.size}</Text>
            <Text style={[styles.cell, { flex: 1 }]}>{row.cct}</Text>
            <Text style={[styles.cell, { flex: 1 }]}>{row.driver}</Text>
            <Text style={[styles.cell, { flex: 1.5 }]}>{row.lSource}</Text>
            <Text style={[styles.cell, { flex: 0.8 }]}>{row.ma}</Text>
            <Text style={[styles.cell, { flex: 0.8 }]}>{row.qty}</Text>
            <Text style={[styles.cellLast, { flex: 1.5 }]}>{row.remarks}</Text>
          </View>
        ))}
      </Page>
    </Document>
  );
};

export default RectificationJobPrint;
